import { AccountsContext } from 'context/accounts/AccountsContext';
import { useContext, useEffect } from 'react';
import { withRouter } from 'react-router';
import { getAccountIdByUrl } from 'utils';

import { AutoDetectActiveAccountProps } from './AutoDetectActiveAccount.types';

export const AutoDetectActiveAccount = withRouter(
  ({ location: { pathname }, history }: AutoDetectActiveAccountProps) => {
    const accountsContext = useContext(AccountsContext);

    useEffect(() => {
      const accountId = getAccountIdByUrl(pathname);

      if (!accountsContext.activeAccount && accountId) {
        if (accountsContext.accounts.filter(a => a.uuid === accountId).length === 0) {
          history.push('/');
        }

        accountsContext.setActiveAccount(accountId);
      } else if (!accountsContext.activeAccount && accountsContext.accounts.length > 0) {
        accountsContext.setActiveAccount(accountsContext.accounts[0].uuid);
      }
    }, [pathname, accountsContext, history]);

    return null;
  },
);
